import React from "react";
import { Select } from "antd";
import NeurapulseLogo from "../../assets/images/neurapulse/neurapulse-logo-icon-blue.png";

export const filterByLinked =
	(filterField: string) => (filter: any, row: any) => {
		if (filter.value === "All") {
			return true;
		}
		if (filter.value === "Linked" && row[filterField] === true) {
			return true;
		}
		if (filter.value === "Unlinked" && row[filterField] === false) {
			return true;
		}
		return false;
	};

const linkedFilters = ["All", "Linked", "Unlinked"];

export const setLinkedCellValue = (row: any) => {
	return row.value === true ? (
		<>
			<img
				src={NeurapulseLogo}
				alt="Neurapulse Link"
				style={{ width: "18px", marginRight: "5px" }}
			/>
			<span>Neurapulse Linked</span>
		</>
	) : (
		""
	);
};

export const LinkedFilterMethod = ({
	filter,
	onChange,
}: {
	filter: any;
	onChange: any;
}) => {
	return (
		<Select
			className="py-0"
			onChange={onChange}
			value={filter ? filter.value : "All"}
		>
			{linkedFilters.map((item) => (
				<Select.Option key={item} value={item}>
					{item}
				</Select.Option>
			))}
		</Select>
	);
};
